import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Production default: silence EIE logs unless explicitly re-enabled.
const enableEieLogs = import.meta.env.VITE_EIE_ENABLE_LOGS === 'true'
if (import.meta.env.PROD && !enableEieLogs) {
  window.__EIE_VERBOSE_LOGS = false
  window._log = () => {}
}

try {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
} catch (e) {
  document.getElementById('root').innerHTML = `<pre style="color:red;padding:2rem">${e.message}\n${e.stack}</pre>`
}
